module.exports = __webpack_public_path__ + "img/baidu-propa.75ebe341.png";